export const SET_AUTH = 'SET_AUTH'
export const SET_WARE_CODE = 'SET_WARE_CODE'
export const REMOVE_AUTH = 'REMOVE_AUTH'